export default __webpack_public_path__ + "static/media/guest_fileShare.07982c52.svg";